import React from 'react';
const links = [{
  label: 'AGB',
  href: '#agb'
}, {
  label: 'Datenschutz',
  href: '#datenschutz'
}, {
  label: 'Kontakt',
  href: '#kontakt'
}, {
  label: 'Impressum',
  href: '#impressum'
}];
export function Footer() {
  return <footer className="bg-brand-navydeep px-4 pb-24 pt-12 text-center text-sm text-white/60 sm:pb-12" data-id="element-71" data-mp="32pff8bhdzhy6">
      <div className="mx-auto max-w-4xl" data-id="element-72" data-mp="36pz9n7aks7gm">
        <div className="flex items-center justify-center gap-2" data-id="element-73" data-mp="3uf0md6qfy4rp">
          <span className="font-script text-2xl italic leading-none text-brand-orange" aria-hidden="true" data-id="element-74" data-mp="3uftkxkf8xnyr">
            ✦
          </span>
          <span className="font-display text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-75" data-mp="3ldkdj3f9yapl">
            Kunst Startklar
          </span>
        </div>
        <p className="mt-2 text-xs text-white/50" data-id="element-76" data-mp="29z6x2jmuoxjl">
          Das komplette Kunst-Curriculum
        </p>
        <nav aria-label="Rechtliches" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-77" data-mp="2ey0a6ay86mj8">
          {links.map(link => <a key={link.label} href={link.href} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-78" data-mp="3lbddywk4gfne">
              {link.label}
            </a>)}
        </nav>
        <p data-id="element-79" data-mp="3q8dj9595dedg">© 2026 Kunst Startklar. Alle Rechte vorbehalten.</p>
      </div>
    </footer>;
}